import { textFilter } from "react-bootstrap-table2-filter";
import {
  ConvertMinutesToTimeRemain,
  CreateTooltip,
  defaultHeaderContainerStyle,
  defaultHeaderIconStyle,
  DicomStatusHeader,
  Gender,
  getCellStyle,
  GetHeaderStyle,
  GetImageStduyStatus,
  GetThaiFormatDateTime,
  UrgentType,
} from "../../core/Helper";
import { GetThaiDateTimeCheckToday } from "../../core/ThaiDate";
import { AiFillClockCircle } from "react-icons/ai";
import { FcCheckmark, FcMinus } from "react-icons/fc";
import { FiCheckCircle, FiFlag, FiUploadCloud } from "react-icons/fi";
import { downloadsFile } from "../radi/StudyHistories";

const customTextFilter = {
  placeholder: "...",
};

const formatVerified = (cell, row) => {
  return (
    <div>
      {row?.diag_verified === "y" ? (
        <FcCheckmark color="#52f805" size={30} />
      ) : (
        <FcMinus style={{ color: "#fd0808" }} size={20} />
      )}
    </div>
  );
};

const formatStatus = (cell, row, callback) => {
  const checkInfo = () => {
    if ([12, 13, 16].includes(Number(row?.action_id))) {
      callback();
    }
  };

  return CreateTooltip(
    <div>
      <div>{row.action_name}</div>
      <div>{GetThaiFormatDateTime(row.action_dt)}</div>
    </div>,
    // + ThaiDate GetThaiDateTime({ dateValue: row.action_dt })
    <div onClick={() => checkInfo()}>
      <GetImageStduyStatus id={row.action_id} />
    </div>
  );
};

const getDateTimeFormat = (cell, row) => {
  return row.is_study_old == "n" ? (
    <GetThaiDateTimeCheckToday dateValue={cell} />
  ) : (
    <></>
  );
};

const sendRequestImage = (row, fileStatus) => {
  downloadsFile({ row });
};

export const GetWorkListColumns = ({ isNormal, showResultAction }) => {
  const fontName = "tahoma";
  const fontSize = "14px";
  let col = [
    {
      dataField: "study_date",
      text: "วันทำเคส",
      sort: true,
      headerStyle: () => GetHeaderStyle("120px", null, fontName, fontSize),
      style: getCellStyle(
        "center",
        "var(--date-sent)",
        fontSize,
        fontName
        // "1px solid var(--date-border)"
      ),
      filter: textFilter(customTextFilter),
      formatter: (cell, row) => <GetThaiDateTimeCheckToday dateValue={cell} />,
    },
    {
      dataField: "patientid",
      text: "HN",
      sort: true,
      headerStyle: () => GetHeaderStyle("100px", null, fontName, fontSize),
      style: getCellStyle("center", null, fontSize, fontName),
      filter: textFilter(customTextFilter),
    },

    {
      dataField: "patients_name",
      text: "ชื่อ-สกุล ผู้ป่วย",
      sort: true,
      headerStyle: () => GetHeaderStyle("auto", null, "tahoma", "18px"),
      style: () => getCellStyle("left", null, fontSize, fontName),
      filter: textFilter(customTextFilter),
    },
    {
      dataField: "patients_sex",
      text: "เพศ",
      sort: true,
      headerStyle: () => GetHeaderStyle("50px", null, "tahoma", "18px"),
      style: () => getCellStyle("center"),
      filter: textFilter(customTextFilter),
      formatter: Gender,
    },
    {
      dataField: "modality",
      text: "Modality",
      sort: true,
      headerStyle: () => GetHeaderStyle("80px", null, "tahoma", "18px"),
      style: () => getCellStyle("center"),
      filter: textFilter(customTextFilter),
    },

    {
      dataField: "study_description",
      text: "Description",
      sort: true,
      headerStyle: () => GetHeaderStyle("auto", null, "niramit", "18px"),
      style: () => getCellStyle("left", null, fontSize, fontName),
      filter: textFilter(customTextFilter),
    },
    {
      dataField: "urgenttype_name",
      text: "ความด่วน",
      sort: true,
      headerStyle: () => GetHeaderStyle("90px", null, "niramit", "18px"),
      formatter: UrgentType,
      style: getCellStyle(
        "left",
        "#07d4f8",
        fontSize,
        fontName
        // "1px solid var(--date-border)"
      ),
      filter: textFilter(customTextFilter),
    },

    {
      dataField: "radi_nickname",
      text: "รังสีแพทย์",
      sort: true,
      headerStyle: () => GetHeaderStyle("120px", null, "niramit", "18px"),
      style: getCellStyle(
        "left",
        "#334155",
        fontSize,
        fontName
        // "1px solid var(--date-border)"
      ),
      filter: textFilter(customTextFilter),
    },

    {
      dataField: "upload_date",
      text: "ส่งอ่าน",
      sort: true,
      headerStyle: () => GetHeaderStyle("110px", null, "niramit", "18px"),
      style: getCellStyle("center", "var(--date-sent)", fontSize, fontName),
      filter: textFilter(customTextFilter),
      formatter: getDateTimeFormat,
    },
    // result_expected
    {
      dataField: "result_expected",
      text: "นัดรับผล",
      sort: true,
      headerStyle: () => GetHeaderStyle("110px", null, "niramit", "18px"),
      style: getCellStyle("center", "var(--date-appoint)", fontSize, fontName),
      filter: textFilter(customTextFilter),
      formatter: getDateTimeFormat,
    },
    {
      dataField: "radi_received_time",
      text: "พ.รับเคส",
      sort: true,
      headerStyle: () => GetHeaderStyle("110px", null, "niramit", "18px"),
      style: getCellStyle("center", "#334155", fontSize, fontName),
      filter: textFilter(customTextFilter),
      formatter: getDateTimeFormat,
    },
    {
      dataField: "radi_finalized_time",
      text: "พ.ส่งผล",
      sort: true,
      headerStyle: () => GetHeaderStyle("110px", null, "niramit", "18px"),
      style: getCellStyle("center", "var(--date-accepted)", fontSize, fontName),
      filter: textFilter(customTextFilter),
      formatter: getDateTimeFormat,
    },
    {
      dataField: "remaining_time",
      text: CreateTooltip("เวลาคงเหลือ", <AiFillClockCircle />),
      sort: true,
      headerStyle: () => GetHeaderStyle("80px"),
      style: getCellStyle(
        "center",
        "var(--date-remaining)",
        fontSize,
        fontName
      ),
      filter: textFilter(customTextFilter),
      formatter: (cell, row) =>
        row.is_study_old == "n" ? (
          ConvertMinutesToTimeRemain(row.remaining_time)
        ) : (
          <></>
        ),
    },

    {
      dataField: "test",
      text: CreateTooltip(
        "ดาวส์โหลด",
        <div style={defaultHeaderContainerStyle}>
          <FiUploadCloud style={defaultHeaderIconStyle} />
        </div>
      ),
      style: getCellStyle("center"),
      headerStyle: GetHeaderStyle("80px", "middle"),
      // formatter: (x, row) => DicomStatusHeader(x, row),
      formatter: (cell, row) => {
        return CreateTooltip(
          "download",
          DicomStatusHeader(cell, row, null, sendRequestImage),
          "top"
        );
      },
    },

    {
      dataField: "action_event",
      text: CreateTooltip(
        "สถานะเคส",
        <div style={defaultHeaderContainerStyle}>
          <FiFlag style={defaultHeaderIconStyle} />
        </div>
      ),
      headerStyle: () => GetHeaderStyle("120px"),
      style: getCellStyle("center", null, fontSize, fontName),
      formatter: (cell, row) => formatStatus(cell, row, showResultAction),
      align: "center",
    },
  ];

  if (isNormal ?? false)
    col = [
      ...col,
      {
        dataField: "diag_verified",
        text: CreateTooltip(
          "สมบูรณ์",
          <div style={defaultHeaderContainerStyle}>
            <FiCheckCircle style={defaultHeaderIconStyle} />
          </div>
        ),

        headerStyle: () => GetHeaderStyle("50px"),
        style: getCellStyle("center"),
        formatter: formatVerified,
        align: "center",
      },
    ];

  return col;
};
